import React from "react";
import { Navigate } from "react-router-dom";

export default function RequireAuth({ children }) {
  const isLoggedIn = localStorage.getItem("adminSession");
  return isLoggedIn ? children : <Navigate to="/admin/login" replace />;
}
